import { render, staticRenderFns } from "./PhoenixWelcome.vue?vue&type=template&id=2c49e6a4&scoped=true"
import script from "./PhoenixWelcome.vue?vue&type=script&lang=js"
export * from "./PhoenixWelcome.vue?vue&type=script&lang=js"
import style0 from "./PhoenixWelcome.vue?vue&type=style&index=0&id=2c49e6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49e6a4",
  null
  
)

export default component.exports